import * as React from "react";
import { cn } from "@/shared/lib/utils";

interface IPhoneButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
}

const PhoneButton = React.forwardRef<HTMLButtonElement, IPhoneButtonProps>(
    ({ children, className, ...props }, ref) => {
        return (
            <button
                ref={ref}
                className={cn(
                    'flex items-center gap-[10px] px-[20px] h-[44px]',
                    'shadow-glass border-[0.5px] border-white-50 !leading-none rounded-full font-manrope text-[16px] transition-all ease-linear duration-200',
                    
                    'bg-white-10',
                    'hover:bg-white-20',
                    'active:bg-white-50',
                    
                    className
                )}
                {...props}
            >
                {children}
            </button>
        );
    }
);

PhoneButton.displayName = "PhoneButton";

export default PhoneButton;